<template>
	<div class="container">
    <p v-lang.line1></p><br>
           <p v-lang.line2></p>
		<form action="http://kontakt.schuett-biotec.de/process.php" method="post" enctype="multipart/form-data" v-on:submit="submit" id="kontakt">
          <input type="hidden" name="form_tools_form_id" value="4" />
            <table cellspacing=0 cellpadding=0 width=488>
              <tr align=LEFT valign=TOP>
                <td width="91"><p v-lang.firma></p></td>
                <td width=397>
                  <input id="realname" type="text" name="firma" value="" size=55 maxlength=60>
                </td>
              </tr>
              <tr valign="top" align="left">
                <td width=91>
                  <p v-lang.institut></p>
                </td>
                <td width=397>
                  <input id="FormularTextfeld5" type="text" name="institut" value="" size=55 maxlength=60>
                </td>
              </tr>
              <tr valign="top" align="left">
                <td width=91>
                  <p v-lang.abteilung></p>
                </td>
                <td width=397>
                  <input id="FormularTextfeld9" type="text" name="abteilung" value="" size=55 maxlength=60>
                </td>
              </tr>
              <tr valign="top" align="left">
                <td width=91>
                  <p v-lang.strasse></p>
                </td>
                <td width=397>
                  <input id="FormularTextfeld6" type="text" name="strasse" value="" size=55 maxlength=60>
                </td>
              </tr>
              <tr valign="top" align="left">
                <td width=91>
                  <p v-lang.postal></p>
                </td>
                <td width=397>
                  <input id="FormularTextfeld7" type="text" name="plz_ort" value="" size=55 maxlength=60>
                </td>
              </tr>
              <tr valign="top" align="left">
                <td width=91><p v-lang.country></p></td>
                <td width=397><input type="text" name="land" size="55" maxlength="60"></td>
              </tr>
              <tr valign="top" align="left">
                <td width=91>
                  <p v-lang.tel></p>
                </td>
                <td width=397>
                  <input id="FormularTextfeld10" type="text" name="telefon" value="" size=55 maxlength=60>
                </td>
              </tr>
              <tr valign="top" align="left">
                <td width=91>
                  <p v-lang.fax></p>
                </td>
                <td width=397>
                  <input id="FormularTextfeld11" type="text" name="fax" value="" size=55 maxlength=60>
                </td>
              </tr>
              <tr valign="top" align="left">
                <td width=91>
                  <p v-lang.email></p>
                </td>
                <td width=397>
                  <input id="email" type="text" name="email" value="" size=55 maxlength=60>
                </td>
              </tr>
              <tr valign="top" align="left">
                <td width=91><p v-lang.internet></p></td>
                <td width=397><input type="text" name="internet" size="55" maxlength="60"></td>
              </tr>
            </table>
            <p><input type="reset" name="ularSchaltfläche2" value="Löschen" id="FormularSchaltfläche2"> <input type="submit" name="send-button" value="Abschicken" id="FormHandler6"></p>
          </form>
	</div>
</template>
<script>
export default {
    name: 'newsletter',
    data () {
      return {}
    },
    methods: {
      postAjax: function (url, data, success) {
        var params = typeof data == 'string' ? data : Object.keys(data).map(
          function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
        ).join('&')

        var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP")
        xhr.open('POST', url)
        xhr.onreadystatechange = function() {
            if ( xhr.readyState > 3 && xhr.status === 200) { success(xhr.responseText) }
        }
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
        xhr.send(params)
        return xhr
      },
      submit: function (event) {
        var form = document.getElementById('prospekt')
        var FD = new FormData(form)
        this.postAjax(form.getAttribute('action'), FD, function (text) {
          console.log(text)
        })
    }
  },
  messages: {
    de: {
      line1: 'Sie haben Interesse, Neues über unsere Produkte zu erfahren und andere wichtige Informationen zu erhalten?',
      line2: 'Wir liefern Ihnen diese regelmäßig direkt in Ihr E-Mail-Postfach...',
      firma: 'Firma',
      institut: 'Institut',
      abteilung: 'Abteilung',
      strasse: 'Straße',
      postal: 'PLZ/Ort',
      country: 'Land',
      tel: 'Telefon',
      fax: 'Telefax',
      email:'E-Mail',
      internet: 'Website'
    },
    en: {
      line1: 'You are interested in getting news on our products and further important information?',
      line2: 'We may regularly send them directly to your e-mail account...',
      firma: 'Company',
      institut: 'Institute',
      abteilung: 'Department',
      strasse: 'Street',
      postal: 'Post code/City',
      country: 'Country',
      tel: 'Phone',
      fax: 'Fax',
      email:'E-mail',
      internet: 'Website'
    }
  }
}
</script>
<style scoped>
	.container {
    color: black;
    margin: 1rem;
  }
  #kontakt {
    padding-top: 2em;
    padding-left: 2rem;
  }
  td {
    border: none;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/newsletter.vue